import { CellItem } from '../../components/core/DataTable/dataTable.types';

export interface EmailReport extends CellItem {
  id: number;
  type: string;
  name: string;
  emailSubject: string;
  dateTimeFormat: string;
  shiftId: number;
  timeZone: string;
  sendOnMonday: boolean;
  sendOnTuesday: boolean;
  sendOnWednesday: boolean;
  sendOnThursday: boolean;
  sendOnFriday: boolean;
  sendOnSaturday: boolean;
  sendOnSunday: boolean;
  intParam1: number | null;
  startOfWeek: string;
  endShiftId: number | null;
  endOfWeek: string;
}

// *** Forms ***
export interface EmailReportInputs {
  id?: number;
  type?: string;
  name?: string;
  emailSubject?: string;
  dateTimeFormat?: string;
  shiftId?: number;
  timeZone?: string;
  sendOnMonday?: boolean;
  sendOnTuesday?: boolean;
  sendOnWednesday?: boolean;
  sendOnThursday?: boolean;
  sendOnFriday?: boolean;
  sendOnSaturday?: boolean;
  sendOnSunday?: boolean;
  intParam1?: number | null;
  startOfWeek?: string;
  endShiftId?: number | null;
  endOfWeek?: string;
}

// *** Requests ***
export interface EmailReportUpdateRequest {
  id: number;
  type: string;
  name: string;
  emailSubject: string;
  dateTimeFormat: string;
  shiftId: number;
  timeZone: string;
  sendOnMonday: boolean;
  sendOnTuesday: boolean;
  sendOnWednesday: boolean;
  sendOnThursday: boolean;
  sendOnFriday: boolean;
  sendOnSaturday: boolean;
  sendOnSunday: boolean;
  intParam1?: number | null;
  startOfWeek?: string;
  endShiftId?: number | null;
  endOfWeek?: string;
}

export interface EmailReportCreateRequest {
  type: string;
  name: string;
  emailSubject: string;
  dateTimeFormat: string;
  shiftId: number;
  timeZone: string;
  sendOnMonday?: boolean;
  sendOnTuesday?: boolean;
  sendOnWednesday?: boolean;
  sendOnThursday?: boolean;
  sendOnFriday?: boolean;
  sendOnSaturday?: boolean;
  sendOnSunday?: boolean;
  intParam1?: number | null;
  startOfWeek?: string;
  endShiftId?: number | null;
  endOfWeek?: string;
}

export interface EmailReportType {
  code: string;
  name: string;
}
export interface TimeZone {
  id: string;
  name: string;
}

export const reportTypes: EmailReportType[] = [
  {
    code: 'HourlyPerformance',
    name: 'Hourly performance',
  },
  {
    code: 'DailyPerformance',
    name: 'Daily performance',
  },
  {
    code: 'WeeklyPerformance',
    name: 'Weekly performance',
  },
  {
    code: 'WeeklyPerformanceVar2',
    name: 'Weekly performance var 2',
  },
];

export const reportDaysOfWeek: EmailReportType[] = [
  {
    code: 'Monday',
    name: 'Monday',
  },
  {
    code: 'Tuesday',
    name: 'Tuesday',
  },
  {
    code: 'Wednesday',
    name: 'Wednesday',
  },
  {
    code: 'Thursday',
    name: 'Thursday',
  },
  {
    code: 'Friday',
    name: 'Friday',
  },
  {
    code: 'Saturday',
    name: 'Saturday',
  },
  {
    code: 'Sunday',
    name: 'Sunday',
  },
];
